import type { App } from 'vue';
import { vDis } from './dis';
import { vSize } from './size';
import { vColor } from './color';
import { vAlign } from './align';
import { vTip } from './tip';
import { vLoading } from './loading';
import { vHide } from './hide';
import { vPress } from './press';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vAlign, vColor, vDis, vLoading, vSize, vTip, vHide, vPress };
